import { Box, Divider, FormControl, TextField } from "@mui/material";
import dayjs from "dayjs";
import Dropdown from "../../AddStudy/DropDown";
import { Study, User } from "../../models";
import ManageEditorsControl from "../ManageEditorsControl";

import { EditStudyContext } from "../useEditStudyContext";
import EditStudyDocumentFiles from "./EditStudyDocumentFiles";

interface EditStudyOverviewProps {
  study_metadata: Study;
  edit_context: EditStudyContext;
}

export default function EditStudyOverview({ study_metadata, edit_context }: EditStudyOverviewProps) {
  const { setStudy, study } = edit_context;

  const handleUpdateEditors = (editors: User[]) => {
    setStudy((_study) => ({
      ..._study,
      editors: editors.map((_) => _.auth_user_id),
    }));
  };

  return (
    <Box>
      <FormControl
        size="medium"
        variant="outlined"
        fullWidth
        sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        <Box sx={{ display: "flex", gap: "1rem" }}>
          <Dropdown
            label="*Vendor Name"
            array={[]}
            value={study_metadata.vendor.vendor_name}
            disabled={true}
            onChange={(value) => {
              // setVendorName(value);
            }}
          />
          <Dropdown
            label="*Therapeutic Area"
            array={[]}
            disabled={true}
            value={study_metadata.therapeutic_area.therapeutic_area_name}
            onChange={(value) => {
              // setTherapeuticArea(value);
            }}
          />
        </Box>
        <Box sx={{ display: "flex", gap: "1rem" }}>
          <TextField
            fullWidth
            label="*Study Name"
            variant="outlined"
            required
            disabled={true}
            value={study_metadata.study_name}
            onChange={(e) => {
              // setStudyName(e.target.value);
            }}
          />
          <Dropdown
            label="*Product | Brand"
            array={[]}
            value={study_metadata.product.product_name}
            disabled={true}
            onChange={(value) => {
              // setBrand(value);
            }}
          />
        </Box>
        <Box sx={{ display: "flex", gap: "1rem" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flex: 1,
              gap: "1rem",
            }}
          >
            <TextField
              label="Start Date"
              variant="outlined"
              required
              fullWidth
              InputLabelProps={{ shrink: true }}
              type="date"
              disabled={true}
              inputProps={{ pattern: "\\d{2}-\\d{2}-\\d{4}", placeholder: "MM-DD-YYYY" }}
              onChange={(e) => {
                // setStartDate(e.target.value)
              }}
              value={dayjs(study_metadata.study_start_date).format("YYYY-MM-DD")}
            />
            -
            <TextField
              label="End Date"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={dayjs(study_metadata.study_end_date).format("YYYY-MM-DD")}
              type="date"
              disabled={true}
              inputProps={{ pattern: "\\d{2}-\\d{2}-\\d{4}", placeholder: "MM-DD-YYYY" }}
              onChange={(e) => {
                // setEndDate(e.target.value);
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Dropdown
              label="*Study Type"
              array={["Quantitative", "Qualitative"]}
              value={study_metadata.study_type}
              disabled={true}
              onChange={(value) => {
                //   setStudyType(value);
              }}
            />
          </Box>
        </Box>
        <ManageEditorsControl editors={study.editors ?? []} onSaveEditors={handleUpdateEditors} />
      </FormControl>

      <Divider sx={{ mt: "2rem", mb: "1.5rem" }} />

      <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        <EditStudyDocumentFiles study={study_metadata} edit_context={edit_context} />
      </Box>
    </Box>
  );
}
